import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  LIST_FETCHED,
  UPDATED,
  CREATED,
  TOGGLE_LOADING,
  SET_DEFAULT,
  DEL_DEFAULT
} from './actionTypes'

const initializeState = Map({
  entries: Map(),
  address: List(),
  demand: List(),
  fetching: false,
  total: 0
})

export default createReucer({
  [TOGGLE_LOADING]: (state) => state.update('fetching', fetching => !fetching),

  [LIST_FETCHED]: (state, { payload }) => {
    const { data } = payload
    return state
      .set('entries', Map(fromJS(data)))
      .set('address', List(fromJS(data.address || [])))
      .set('demand', List(fromJS(data.feedback_demand || [])))
  },
  // 删除
  [DEL_DEFAULT]: (state, { payload }) => {
    const { valuesType, row } = payload
    return state
      .update(valuesType, address => address.filter(ele => (ele && ele.get(valuesType) !== row[valuesType])))
  },
  // 设置默认
  [SET_DEFAULT]: (state, { payload }) => {
    const { valuesType, row } = payload
    return state
      .update(valuesType, address => address.map(ele => {
        let obj = Map()
        if (valuesType === "demand") {
          obj = new Map({ [valuesType]: ele.get(valuesType), is_fault: false })
          if (ele.get(valuesType) === row[valuesType] && !ele.get("is_fault")) {
            obj = new Map({ [valuesType]: row[valuesType], is_fault: true })
          }
        }
        if (valuesType === "address") {
          obj = new Map({ [valuesType]: ele.get(valuesType), is_fault: false, pay_type: ele.get("pay_type"), express: ele.get("express")})
          if (ele.get(valuesType) === row[valuesType] && !ele.get("is_fault")) {
            obj = new Map({ [valuesType]: row[valuesType], is_fault: true, pay_type: ele.get("pay_type"), express: ele.get("express") })
          }
        }
        return obj
      }))
  },
  // 修改数据
  [UPDATED]: (state, { payload }) => {
    const { type, valuesType, data, originalValue, values } = payload
    return state
      .update(valuesType, address => address.map(ele => {
        let obj = Map()
        obj = ele
        if (valuesType === "demand") {
          if (ele.get(valuesType) === originalValue[valuesType]) {
            obj = new Map({ [valuesType]: data, is_fault: originalValue.is_fault })
          }
        }
        if (valuesType === "address") {
          if (ele.get(valuesType) === originalValue[valuesType]) {
            obj = new Map({[valuesType]: data, is_fault: originalValue.is_fault, pay_type: values.pay_type, express: values.express })
          }
        }
        return obj
      }))
  },
  // 添加数据
  [CREATED]: (state, { payload }) =>
    state
      .update(payload.valuesType, address => address.unshift(payload.valuesType === "address" ?
        Map({[payload.valuesType]: payload.data, is_fault: false, pay_type: payload.values.pay_type, express: payload.values.express}) :
        Map({[payload.valuesType]: payload.data, is_fault: false }))
      ),
}, initializeState)
